import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'

const PathMap = ({ pageName, paths = [] }) => {
  const navigate = useNavigate()

  const filteredPaths = (paths || []).filter(
    (item) => item?.name?.trim().toLowerCase() !== 'home'
  )

  const hasIcon = Boolean(pageName?.icon)
  const hasTitle = Boolean(pageName?.title)
  const hasPaths = filteredPaths.length > 0

  if (!hasIcon && !hasTitle && !hasPaths) {
    return null
  }

  return (
    <div className='flex gap-2 justify-cente items-center px-4 mt-3'>
      {pageName?.icon && (
        <Link
          to={pageName?.backPath || "#"}
          onClick={(e) => {
            if (!pageName?.backPath) {
              e.preventDefault();
              navigate(-1);
            }
          }}
        >
          <Button className='bg-cyellow text-cblack' size={`icon`}>
            <ArrowLeft />
          </Button>
        </Link>
      )}
      <div className='flex flex-col'>
        {pageName?.title && (
          <h2 className='text-cwhite  font-medium'>{pageName?.title}</h2>
        )}
        {hasPaths && (
          <nav className='text-sm py-1 -mt-1'>
            {filteredPaths.map((item, index) => {
              const isLast = index === filteredPaths.length - 1
              return (
                <span key={index} className='inline-flex items-center'>
                  {!isLast ? (
                    <Link
                      to={item.path}
                      className='text-color4 hover:text-cyellow transition duration-200'
                    >
                      {item.name}
                    </Link>
                  ) : (
                    <span className='text-cyellow font-semibold'>
                      {item.name}
                    </span>
                  )}
                  {!isLast && <span className='mx-2 text-color4'>{'>'}</span>}
                </span>
              )
            })}
          </nav>
        )}
      </div>
    </div>
  )
}

export default PathMap
